import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useDeepLinkRedirect } from "hooks/useDeepLinkRedirect";
import { getPaymentActionRoute } from "utils/paymentActionRoute";

const PaymentActionRedirect = () => {
  const { type, id } = useParams<{ type: string; id: string }>();
  const route = useMemo(() => getPaymentActionRoute(type, id), [type, id]);

  useDeepLinkRedirect(route);

  return (
    <div className="h-[var(--shell-vh)] w-full grid place-items-center">
      <div
        className="inline-block h-10 w-10 animate-spin rounded-full border-2 border-solid border-blue border-r-transparent"
        role="status"
        aria-label="Opening payment"
      />
    </div>
  );
};

export default PaymentActionRedirect;
